import { Routes } from '@angular/router';

import { authGuard, channelGuard, guestGuard, homeRedirectGuard, permissionGuard,stageGuard } from './guards/auth-guard';
import { DefaultLayoutComponent } from './layouts/default/default.component';


export const routes: Routes = [

  /* ────────────────────────────────────────────── */
  /* GUEST ROUTES                                   */
  /* ────────────────────────────────────────────── */
  /*{ 
    path: 'signin', 
    canActivate: [guestGuard],
    loadComponent: () => import('./pages/signin/signin.page').then( m => m.SigninPage)  
  },
  */
  { 
    path: 'lost-password',
    canActivate: [guestGuard],
    loadComponent: () => import('./pages/lost-password/lost-password.page').then( m => m.LostPasswordPage) 
  },
  { 
    path: 'magic',
    canActivate: [guestGuard],
    loadComponent: () => import('./pages/account/magic-request/magic-request.page').then( m => m.MagicRequestPage) 
  },
  { 
    path: 'magic/:uuid/:token', 
    canActivate: [guestGuard],
    loadComponent: () => import('./pages/account/magic-validate/magic-validate.page').then( m => m.MagicValidatePage) 
  },

  { 
    path: 'signin', 
    canActivate: [guestGuard],
    loadComponent: () => import('./pages/account/signin/signin.page').then( m => m.SigninPage)  
    
  },

  // SSO callback route – NO guards
  { 
    path: 'auth', 
    canActivate: [guestGuard],
    loadComponent: () => import('./pages/account/auth/auth.page').then(m => m.AuthPage) 
  },

  
  {
    path: '',
    component: DefaultLayoutComponent,     // 👈 layout with split-pane + menu
    canActivate: [authGuard],              // global auth guard for all children
    children: [
      /* ────────────────────────────────────────────── */
      /* HOME ROUTES BASED ON APPLICATION STAGE         */
      /* ────────────────────────────────────────────── */
      // redirect based on application stage
      { 
        path: '',
        canActivate: [
          homeRedirectGuard, 
        ],
        children: [],
        pathMatch: 'full'
        
        
      },
      // assessor home page
      { 
        path: 'home',
        
        canActivate: [
          //authGuard, 
          stageGuard([
            'Assessor',
            'Rejected',
          ])
          
        ],
        loadComponent: () => import('./pages/home/home.page').then(m => m.HomePage) 
      },
      // applying home page
      { 
        path: 'applying',
        canActivate: [
          authGuard, 
          stageGuard([
            'Applying'
          ])
        ],
        loadComponent: () => import('./pages/home/applying/applying.page').then(m => m.ApplyingPage) 
      },

      // applicant home page
      {
        path: 'applicant',
        canActivate: [
          authGuard, 
          stageGuard([
            'Applicant'
          ])
        ],
        loadComponent: () => import('./pages/home/applicant/applicant.page').then( m => m.ApplicantPage)
      },

       {
          path: 'application-status',
          canActivate: [
          authGuard, 
          stageGuard([
            'Rejected'
          ])
        ],
          loadComponent: () => import('./pages/home/rejected/rejected.page').then( m => m.RejectedPage)
        },

        {
          path: 'account-status',
          canActivate: [
            authGuard, 
          ],
          loadComponent: () => import('./pages/home/account-status/account-status.page').then( m => m.AccountStatusPage)
        },
      

      /* ────────────────────────────────────────────── */
      /* ASSESSOR ROUTES                                */
      /* ────────────────────────────────────────────── */
      // list of assessments
      { 
        path: 'assessment-list',
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor'
          ])
        ],
        loadComponent: () => import('./pages/assessment-list/assessment-list.page').then( m => m.AssessmentListPage)  
      },
      // complete assessment
      { 
        path: 'assessment/:id',
        data: {
          hideMainMenu: true,
          layoutMode: 'assessment',
        },
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor'
          ])
        ],
        loadComponent: () => import('./pages/assessment/assessment.page').then( m => m.AssessmentPage)  
      },

      {
        path: 'missions',
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor'
          ])
        ],
        loadComponent: () => import('./pages/missions/missions.page').then( m => m.MissionsPage)
      },

      {
        path: 'missions/map',
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor'
          ])
        ],
        loadComponent: () => import('./pages/missions/map/map.page').then( m => m.MapPage)
      },

      // Pulse
      {
        path: 'pulse',
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor'
          ])
        ],
        children: [
          { path: '', loadComponent: () => import('./pages/pulse/pulse-menu/pulse-menu.page').then(m => m.PulseMenuPage ),      },
          { path: 'pulse-menu', loadComponent: () => import('./pages/pulse/pulse-menu/pulse-menu.page').then(m => m.PulseMenuPage ),      },
          { path: 'pulse-history', loadComponent: () => import('./pages/pulse/pulse-history/pulse-history.page').then(m => m.PulseHistoryPage ),      },
          { path: 't-and-c', loadComponent: () => import('./pages/pulse/t-and-c/t-and-c.page').then( m => m.TAndCPage) },

          { path: ':type', loadComponent: () => import('./pages/pulse/pulse/pulse.page').then( m => m.PulsePage) },
        ]
      },

      // news list
      { 
        path: 'news',
        data: { kind: 'news' },
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor'
          ])
        ],
        loadComponent: () => import('./pages/news/news-index/news-index.page').then( m => m.NewsIndexPage)  
      },
      { 
        path: 'resources',
        data: { kind: 'resources' },
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor'
          ])
        ],
        loadComponent: () => import('./pages/news/news-index/news-index.page').then( m => m.NewsIndexPage)  
      },
      // news item
      { 
        path: 'news/:ref',
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor'
          ])
        ],
        loadComponent: () => import('./pages/news/news-item/news-item.page').then( m => m.NewsItemPage)  
      },

      {
        path: 'contact',
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor'
          ])
        ],
        loadComponent: () => import('./pages/contact/contact.page').then( m => m.ContactPage)
      },

      {
        path: 'contact/meet-the-team',
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor'
          ])
        ],
        loadComponent: () => import('./pages/contact/meet-the-team/meet-the-team.page').then( m => m.MeetTheTeamPage)
      },
  

      // news item
      { 
        path: 'emergency-contact',
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor'
          ])
        ],
        loadComponent: () => import('./pages/contact/emergency-contact/emergency-contact.page').then( m => m.EmergencyContactPage)
      },
      // Invoices
      {
        path: 'invoices',
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor'
          ])
        ],
        loadComponent: () => import('./pages/invoices/index/index.page').then( m => m.IndexPage)
      },

      {
        path: 'invoices/history',
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor'
          ])
        ],
        loadComponent: () => import('./pages/invoices/history/history.page').then( m => m.HistoryPage)
      },

      {
        path: 'invoices/invoiceables',
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor'
          ])
        ],
        loadComponent: () => import('./pages/invoices/invoiceables/invoiceables.page').then( m => m.InvoiceablesPage)
      },
      {
        path: 'invoices/raise/:id',
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor'
          ])
        ],
        loadComponent: () => import('./pages/invoices/raise/raise.page').then( m => m.RaisePage)
      },

      // account
      {
        path: 'account',
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor',
            'Applicant',
            //'Applying',
          ])
        ],
        loadComponent: () => import('./pages/account/index/index.page').then( m => m.IndexPage)
      },

       {
        path: 'account/delete',
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor',
            'Applicant',
            'Applying',
            'Rejected',
          ])
        ],
        loadComponent: () => import('./pages/account/delete/delete.page').then( m => m.DeletePage)
      },

      {
        path: 'account/passkeys',
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor',
            'Applicant',
            //'Applying',
          ])
        ],
        loadComponent: () => import('./pages/account/passkeys/passkeys.page').then( m => m.PasskeysPage)
      },

      {
        path: 'account/password',
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor',
            'Applicant',
            //'Applying',
          ])
        ],
        loadComponent: () => import('./pages/account/password/password.page').then( m => m.PasswordPage)
      },
      {
        path: 'account/email',
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor',
            'Applicant',
            //'Applying',
          ])
        ],
        loadComponent: () => import('./pages/account/email/email.page').then( m => m.EmailPage)
      },

      {
        path: 'account/profile',
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor',
            'Applicant',
            //'Applying',
          ])
        ],
        loadComponent: () => import('./pages/account/profile/profile.page').then( m => m.ProfilePage)
      },

      {
        path: 'account/availability',
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor',
            'Applicant',
            //'Applying',
          ])
        ],
        loadComponent: () => import('./pages/account/availability/list/list.page').then( m => m.ListPage)
      },

      {
        path: 'account/payment-details',
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor',
            'Applicant',
            //'Applying',
          ])
        ],
        loadComponent: () => import('./pages/account/payment-details/form/form.page').then( m => m.FormPage)
      },

      {
        path: 'account/eligibility-to-work',
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor',
            'Applicant',
            //'Applying',
          ])
        ],
        loadComponent: () => import('./pages/account/eligibility-to-work/eligibility-to-work.page').then( m => m.EligibilityToWorkPage)
      },
      {
        path: 'account/out-of-area',
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor',
            'Applicant',
            //'Applying',
          ])
        ],
        loadComponent: () => import('./pages/account/out-of-area/out-of-area.page').then( m => m.OutOfAreaPage)
      },
      

      {
        path: 'account/tokens',
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor',
            'Applicant',
            //'Applying',
          ])
        ],
        loadComponent: () => import('./pages/account/tokens/tokens.page').then( m => m.TokensPage)
      },
      {
        path: 'videos',
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor',
            'Applicant',
            //'Applying',
          ])
        ],
        loadComponent: () => import('./pages/video/video-list/video-list.page').then( m => m.VideoListPage)
      },
      {
        path: 'video/:id',
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor',
            'Applicant',
            //'Applying',
          ])
        ],
        loadComponent: () => import('./pages/video/video.page').then( m => m.VideoPage)
      },

      {
        path: 'forum',
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor',
            //'Applicant',
            //'Applying',
          ])
        ],
        loadComponent: () => import('./pages/forum/forum-categories/forum-categories.page').then( m => m.ForumCategoriesPage)
      },

      {
        path: 'forum/:categoryId/:threadId',
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor',
            //'Applicant',
            //'Applying',
          ])
        ],
        loadComponent: () => import('./pages/forum/forum-thread/forum-thread.page').then( m => m.ForumThreadPage)
      },

      {
        path: 'forum/:categoryId',
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor',
            //'Applicant',
            //'Applying',
          ])
        ],
        loadComponent: () => import('./pages/forum/forum-threads/forum-threads.page').then( m => m.ForumThreadsPage)
      },


 
        
      

      {
        path: 'interest',
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor',
            'Applicant',
            //'Applying',
          ])
        ],
        loadComponent: () => import('./pages/interest/interest-list/interest-list.page').then( m => m.InterestListPage)
      },
      {
        path: 'interest/:id',
        canActivate: [
          authGuard, 
          stageGuard([
            'Assessor',
            'Applicant',
            //'Applying',
          ])
        ],
        loadComponent: () => import('./pages/interest/interest-detail/interest-detail.page').then( m => m.InterestDetailPage)
      },
      




     
      // users
      {
        path: 'users',
        canActivate: [
          authGuard, 
          permissionGuard('userRead')
        ],
        loadComponent: () => import('./pages/users/user-index/user-index.page').then( m => m.UserIndexPage)
      },
      // settings
      {
        path: 'settings',
        canActivate: [
          authGuard, 
          
        ],
        children: [
          { path: '', loadComponent: () => import('./pages/settings/settings.page').then(m => m.SettingsPage),      },

          
          { path: 'db',         canActivate: [channelGuard('Alpha')],  loadComponent: () => import('./pages/settings/db/db.page').then(m => m.DbPage), },
          { path: 'db/:table',  canActivate: [channelGuard('Alpha')], loadComponent: () => import('./pages/settings/db-table/db-table.page').then(m => m.DbTablePage),},
          { path: 'storage',    canActivate: [channelGuard('Alpha')],  loadComponent: () => import('./pages/settings/storage/storage.page').then(m => m.StoragePage), },
          { path: 'storage/:key',   canActivate: [channelGuard('Alpha')], loadComponent: () => import('./pages/settings/storage-key/storage-key.page').then(m => m.StorageKeyPage), },
        ],
      },
    ]
  },
  {
    path: 'auth',
    loadComponent: () => import('./pages/account/auth/auth.page').then( m => m.AuthPage)
  },
  {
    path: 'tokens',
    loadComponent: () => import('./pages/account/tokens/tokens.page').then( m => m.TokensPage)
  },
  {
    path: 'password',
    loadComponent: () => import('./pages/account/password/password.page').then( m => m.PasswordPage)
  },
  {
    path: 'email',
    loadComponent: () => import('./pages/account/email/email.page').then( m => m.EmailPage)
  },
  {
    path: 'account/password/forgot',
    loadComponent: () => import('./pages/account/password-forgot/password-forgot.page').then( m => m.PasswordForgotPage)
  },
  {
    path: 'account/password/otp',
    loadComponent: () => import('./pages/account/password-otp/password-otp.page').then( m => m.PasswordOtpPage)
  },
  {
    path: 'account/password/reset',
    loadComponent: () => import('./pages/account/password-reset/password-reset.page').then( m => m.PasswordResetPage)
  },
  {
    path: 'test/header',
    loadComponent: () => import('./pages/test/header/header.page').then( m => m.HeaderPage)
  },
  

 


  

  



  

  



 

  


 

  
  



 

  


 
 
 


  

  


  

  

  

  

  

  

  /*{
    path: 'user-index',
    loadComponent: () => import('./pages/users/user-index/user-index.page').then( m => m.UserIndexPage)
  },
  */

  /*{
    path: 'news-index',
    loadComponent: () => import('./pages/news/news-index/news-index.page').then( m => m.NewsIndexPage)
  },
  {
    path: 'news-item',
    loadComponent: () => import('./pages/news/news-item/news-item.page').then( m => m.NewsItemPage)
  },
  {
    path: 'emergency-contact',
    loadComponent: () => import('./pages/contact/emergency-contact/emergency-contact.page').then( m => m.EmergencyContactPage)
  }
    */



  



  /*{ //guest routes
     path: '',
    canActivate: [guestGuard], // ✅ guard applied here
    children: [
      { path: 'signin', loadComponent: () => import('./pages/signin/signin.page').then( m => m.SigninPage)  },
      { path: 'lost-password', loadComponent: () => import('./pages/lost-password/lost-password.page').then( m => m.LostPasswordPage) },
      { path: 'magic', loadComponent: () => import('./pages/account/magic-request/magic-request.page').then( m => m.MagicRequestPage) },
      { path: 'magic/:uuid/:token', loadComponent: () => import('./pages/account/magic-validate/magic-validate.page').then( m => m.MagicValidatePage) },
    ],
  },
  */
  /*
  { //authed routes
     path: '',
    canActivate: [authGuard], // ✅ guard applied here
    children: [

      //home route to land on
      { path: '',             canActivate: [stageGuard(['Applying'])],       loadComponent: () => import('./pages/home/home.page').then(m => m.HomePage) },
      { path: '',             canActivate: [stageGuard(['Assessor'])],       loadComponent: () => import('./pages/home/home.page').then(m => m.HomePage) },

      { path: 'assessment-list',  loadComponent: () => import('./pages/assessment-list/assessment-list.page').then( m => m.AssessmentListPage)  },
      { path: 'assessment/:id', loadComponent: () => import('./pages/assessment/assessment.page').then( m => m.AssessmentPage)  },


      {
        path: 'settings',
        children: [
          { path: '', loadComponent: () => import('./pages/settings/settings.page').then(m => m.SettingsPage),      },

          
          { path: 'db',         canActivate: [channelGuard('Alpha')],  loadComponent: () => import('./pages/settings/db/db.page').then(m => m.DbPage), },
          { path: 'db/:table',  canActivate: [channelGuard('Alpha')], loadComponent: () => import('./pages/settings/db-table/db-table.page').then(m => m.DbTablePage),},
          { path: 'storage',    canActivate: [channelGuard('Alpha')],  loadComponent: () => import('./pages/settings/storage/storage.page').then(m => m.StoragePage), },
          { path: 'storage/:key',   canActivate: [channelGuard('Alpha')], loadComponent: () => import('./pages/settings/storage-key/storage-key.page').then(m => m.StorageKeyPage), },
        ],
      },
      {
        path: 'pulse',canActivate: [authGuard], 
        children: [
          { path: '', loadComponent: () => import('./pages/pulse/pulse-menu/pulse-menu.page').then(m => m.PulseMenuPage ),      },
          { path: 'pulse-menu', loadComponent: () => import('./pages/pulse/pulse-menu/pulse-menu.page').then(m => m.PulseMenuPage ),      },
          { path: 'pulse-history', loadComponent: () => import('./pages/pulse/pulse-history/pulse-history.page').then(m => m.PulseHistoryPage ),      },
          { path: 'pulse-help', loadComponent: () => import('./pages/pulse/pulse-help/pulse-help.page').then(m => m.PulseHelpPage ),      },
          {  path: ':type', loadComponent: () => import('./pages/pulse/pulse/pulse.page').then( m => m.PulsePage) },
        ]
      },
    ],

  },
  */
  

  

  


  { path: '', redirectTo: 'signin', pathMatch: 'full' },
  { path: '**', redirectTo: 'signin' },



 


  /*{
    path: 'signin',
    loadComponent: () => import('./pages/account/signin/signin.page').then( m => m.SigninPage)
  },
  */

  
  

  

  

  



];
